import { render, staticRenderFns } from "./NewsSingleContent.vue?vue&type=template&id=df78f262&"
import script from "./NewsSingleContent.vue?vue&type=script&lang=js&"
export * from "./NewsSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports